import React, { useEffect, useState } from "react";
import { AiOutlinePlus, AiFillEdit, AiFillDelete } from "react-icons/ai";
import TextField from "@mui/material/TextField";
import Cookies from "universal-cookie";
import { FormControl } from "@mui/material";

const FeaturesCategories = ({ url }) => {
    const [features, setFeatures] = useState([]);
    const [body, setBody] = useState({
        title: "",
        description: "",
        id: ""
    });

    const [mode, setMode] = useState(null);
    const cookies = new Cookies();
    const token = cookies.get("jwt");
    const getFeaturesCategories = async () => {
        try {
            const response = await fetch(`${url}/features/category/all`);
            if (response.ok) {
                const data = await response.json();
                setFeatures(data.data.featuresCategories);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const createFeatureCategory = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${url}/features/category/create`, {
                method: "POST",
                body: JSON.stringify({ title: body.title, description: body.description }),
                headers: {
                    authorization: `${token}`,
                    "Content-Type": "application/json",
                },
            });
            if (response.ok) {
                getFeaturesCategories();
            }

            setMode(null);
            setBody({
                title: "",
                description: "",
                id: ""
            });

        } catch (err) {
            console.log(err);
        }
    };

    const editFeatureCategory = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${url}/features/category/${body.id}`, {
                method: "PATCH",
                body: JSON.stringify({ title: body.title, description: body.description }),
                headers: {
                    authorization: token,
                    "Content-Type": "application/json",
                },
            });
            if (response.ok) {
                getFeaturesCategories();
                // setEditValue("");
            }

            setMode(null);
            setBody({
                title: "",
                description: "",
                id: ""
            });

        } catch (err) {
            console.log(err);
        }
    };

    const deleteFeature = async (id) => {
        try {
            const response = await fetch(`${url}/features/category/${id}`, {
                method: "DELETE",
                headers: {
                    authorization: token,
                },
            });
            if (response.ok) {
                getFeaturesCategories();
            }
            setMode(null);
            setBody({
                title: "",
                description: "",
                id: ""
            });
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getFeaturesCategories();
    }, []);

    const EditComponent = ({ feature, setMode }) => {

        const handleEdit = (e, body) => {
            e.preventDefault();
            setMode("edit")
            setBody({
                title: body.title,
                description: body.description,
                id: body._id
            })
        }
        return (
            <>
                {/* {edit && (
                    <div className="align-items-center mx-4">
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            editFeatureCategory(feature._id);
                        }}>
                            <div className="row">
                                <div className="col-md-4">
                                    <TextField
                                        fullWidth
                                        value={editValue.title}
                                        sx={{ "& > input": { fontSize: "16px" } }}
                                        onChange={(e) => setEditValue({
                                            ...editValue,
                                            [e.target.name]: e.target.value
                                        })}
                                        id="standard-basic"
                                        label="Category Title"
                                        variant="standard"
                                        name="title"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <TextField
                                        fullWidth
                                        value={editValue.description}
                                        sx={{ "& > input": { fontSize: "16px" } }}
                                        onChange={(e) => setEditValue({
                                            ...editValue,
                                            [e.target.name]: e.target.value
                                        })}
                                        id="standard-basic"
                                        label="Description"
                                        variant="standard"
                                        name="description"

                                    />`
                                </div>
                                <div className="col-md-1">
                                    <button onClick={editFeatureCategory} className="btn btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>


                        </form>

                    </div>
                )} */}
                <button
                    style={{ textTransform: "capitalize" }}
                    className={feature.selected ? "feature-selected" : null}
                    id={feature._id}
                    type="button"
                    key={feature._id}
                >
                    <div>{feature.title}</div>
                    <div id="btns">
                        <span onClick={(e) => handleEdit(e, feature)}>
                            <AiFillEdit />
                        </span>
                        <span onClick={() => deleteFeature(feature._id)}>
                            <AiFillDelete />
                        </span>
                    </div>
                </button >

            </>
        )
    };
    return (
        <div>
            <div className="select-features">
                <div className="features-header">
                    <h3 className="text-left">All Features Categories</h3>
                    {/* {add ? (
                        <></>
                    ) : ( */}
                    <div className="text-left mb-4">
                        <button onClick={() => {
                            setMode("add");
                            setBody({
                                title: "",
                                description: "",
                                id: ""
                            });
                        }} className="btn btn-primary">
                            + Create a new category
                        </button>
                    </div>
                    {/* )} */}
                </div>
                {mode && <div className="align-items-center mb-4 w-100">
                    <form onSubmit={mode == "add" ? createFeatureCategory : editFeatureCategory}>
                        <div className="row w-100">
                           <div className="col-md-7">
                                <div className="row">
                                    <div className="col-md-12">
                                        <FormControl variant="standard" fullWidth>

                                            <TextField
                                                fullWidth
                                                value={body.title}
                                                sx={{ "& > input": { fontSize: "16px" } }}
                                                onChange={(e) => setBody({
                                                    ...body,
                                                    [e.target.name]: e.target.value
                                                })}
                                                id="standard-basic"
                                                label="Category Title"
                                                variant="standard"
                                                name="title"
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <FormControl variant="standard" fullWidth>

                                            <TextField
                                                
                                                value={body.description}
                                                sx={{ "& > input": { fontSize: "16px" } }}
                                                onChange={(e) => setBody({
                                                    ...body,
                                                    [e.target.name]: e.target.value
                                                })}
                                                id="standard-basic"
                                                label="Description"
                                                variant="standard"
                                                name="description"

                                            />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-12 mt-4">
                                        <div className="icon text-left">
                                            <button type="submit" className="btn btn-primary">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                           </div>
                        </div>


                    </form>

                </div>}
                <div className="features">
                    {features &&
                        features.length > 0 &&
                        features.sort().map((feature) => {
                            return (
                                <div key={feature._id}>
                                    <EditComponent feature={feature} mode={mode} setMode={setMode} />
                                </div>
                            );
                        })}
                </div>
            </div >
        </div >
    );
};

export default FeaturesCategories;